import http from 'hub-http/clients/apiClient';
const root = `/rollouts-app`;
const betaRoot = `${root}/v2/beta-access-rollout`;
export const RolloutsAPI = {
  enrollBeta: request => http.post(`${betaRoot}/enroll`, {
    data: Object.assign({}, request)
  }),
  leaveBeta: request => http.post(`${betaRoot}/leave`, {
    data: Object.assign({}, request)
  }),
  updateBetaEnrollment: request => http.post(`${betaRoot}/update-enroll-type`, {
    data: Object.assign({}, request)
  })
};